/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult, FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped, FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSON, } from './FxIdApplicationStoreYandexGamesYandexBonusSuccessResult';
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult(json)) {
        return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSON(json) {
    return FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreYandexGamesYandexBonusSuccessResult(value)) {
        return FxIdApplicationStoreYandexGamesYandexBonusSuccessResultToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesYandexBonusResultDataSucccessData.js.map